import React from 'react'
import logo from '../Assets/hostesss for you.png'
import { Link } from 'react-router-dom'
function Footer() {
  return (
    <>
    <div className='footer'>
    <ul className='first-ul'>
        <img className='nav-logo' src={logo}/>
        <br/>
        <br/>
        <p>Vestibulum vulputate vulputate ligula. Tec
Lorem ipsum dolor sit amet, consecteturir
adipiscing elit. vivamus cursus elit.</p>

    </ul>
   

    <ul>The Community
    <br/>
    <br/>
    <Link className='none' to='/howitwoks'>

    <li>How Its Work</li>
    </Link>
    <Link className='none' to='/howitwoks'>

    <li>Credits and Payments</li>
    </Link>

    <li>Help And Contacts</li>
 

    </ul>


    <ul>Links
    <br/>
    <br/>
    <Link className='none' to='/'>

    <li>Home</li>
    </Link>
    <Link className='none' to='/about'>

    <li>About</li>
    </Link>
    <Link className='none' to='/howitwoks'>

    <li>How Its Work</li>
    </Link>
    <Link className='none' to='/allmodal'>

    <li>All Modal</li>
    </Link>
    <Link className='none' to='/contact'>

    <li>Contact Us</li>
    </Link>
    



    </ul>

    
    <ul>Terms & Condition
    <br/>
    <br/>
    <Link className='none' to='/privacypolicy'>

    <li>Privacy Policy</li>
    </Link>

    <Link className='none' to='/tnc'>



    <li>Terms and condition</li>
    </Link>

    <Link className='none' to='/cookies'>



    <li>Cookies information</li>
    </Link>
    <Link className='none' to='/contact'>



    <li>Help And Contacts</li>
    </Link>
    </ul>
    </div>
    <div className='footer-bottom'>
    <p>Dihox © 2024</p>
    </div>

    </>
  )
}

export default Footer